import { Link } from "react-router-dom";
import LazyImage from "./lazyImage";
import AddToCart from "./addToCart/addToCart";
import "./productViewV2.css";
import { formatAmount } from "../../shared/utils/formatters";
const { AddToCartFullText } = AddToCart;

const ProductViewV2 = ({ product, index }) => {
  const discount =
    product?.originalPrice && product?.price
      ? Math.round(
          ((product.originalPrice - product.price) / product.originalPrice) *
            100,
        )
      : 0;

  return (
    <div
      className="col-xxl-2 col-lg-3 col-sm-4 col-6 aos-init aos-animate"
      data-aos="fade-up"
      key={`recommeded-${index}`}
    >
      <div className="product-card pv2-card h-100 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 group-item">
        {product?.label && (
          <span className="product-card__badge bg-warning-600 px-8 py-4 text-white">
            {product?.label}
          </span>
        )}
        {discount > 0 && <span className="pv2-discount">{discount}% OFF</span>}
        <Link
          to={`/product-details/${product?.slug}`}
          className="product-card__thumb flex-center overflow-hidden"
        >
          <LazyImage
            src={product?.image}
            alt={product?.name}
            style={{ objectFit: "contain" }}
          />
        </Link>
        <div className="product-card__content w-100">
          <h6 className="title pv2-title fw-semibold">
            <Link
              to={`/product-details/${product?.slug}`}
              className="link text-line-2"
            >
              {product?.name}
            </Link>
          </h6>
          <div className="pv2-price">
            <span className="pv2-sale">
              {formatAmount(product?.price)}
              <span className="pv2-qty">/{product?.quantityType}</span>
            </span>
            {product?.originalPrice !== product?.price && (
              <span className="pv2-original">
                {formatAmount(product?.originalPrice)}
              </span>
            )}
          </div>
          {/* <AddToCartFullText product={product} /> */}
        </div>
      </div>
    </div>
  );
};

export default ProductViewV2;
